import type { VFC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ModelsList } from './Content';

export const ModelsListRouter: VFC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <ModelsList />
      </Route>
    </Switch>
  );
};
